import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import type { RuleSetId } from '../../../../model';

// DELETE_RULE
export const DELETE_RULE = 'state.actions.rule.delete.DELETE_RULE' as const;

export type DeleteRuleAction = {
	type: typeof DELETE_RULE;
	payload: {
		ruleSetId: string;
	};
	meta: {
		analyticsEvent: UIAnalyticsEvent;
	};
};

export const deleteRuleAction = (
	ruleSetId: string,
	analyticsEvent: UIAnalyticsEvent,
): DeleteRuleAction => ({
	type: DELETE_RULE,
	payload: {
		ruleSetId,
	},
	meta: {
		analyticsEvent,
	},
});

// DELETE_SUCCESS
export const DELETE_SUCCESS = 'state.actions.rule.delete.DELETE_SUCCESS' as const;

export type DeleteSuccessAction = {
	type: typeof DELETE_SUCCESS;
	payload: {
		deletedRuleSetId: string;
	};
};

export const deleteSuccessAction = (deletedRuleSetId: string): DeleteSuccessAction => ({
	type: DELETE_SUCCESS,
	payload: {
		deletedRuleSetId,
	},
});

// DELETE_FAILURE
export const DELETE_FAILURE = 'state.actions.rule.delete.DELETE_FAILURE' as const;

export type DeleteFailureAction = {
	type: typeof DELETE_FAILURE;
	payload: {
		deletedRuleSetId: string;
	};
};

export const deleteFailureAction = (deletedRuleSetId: string): DeleteFailureAction => ({
	type: DELETE_FAILURE,
	payload: {
		deletedRuleSetId,
	},
});

// SET_SHOW_DELETE_DIALOG
export const SET_SHOW_DELETE_DIALOG = 'state.actions.rule.delete.SET_SHOW_DELETE_DIALOG' as const;

export type SetShowDeleteDialogAction = {
	type: typeof SET_SHOW_DELETE_DIALOG;
	payload: {
		ruleSetId: RuleSetId | null;
	};
};

export const setShowDeleteDialogAction = (
	ruleSetId: RuleSetId | null,
): SetShowDeleteDialogAction => ({
	type: SET_SHOW_DELETE_DIALOG,
	payload: {
		ruleSetId,
	},
});
